import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import directives from "./utils/directives";
import element from "@/element/element";
import { VueJsonp } from "vue-jsonp";
import "@/assets/style/common.scss";
import "@/assets/fonts/iconfont.css";
import "@/permission";
import Print from "@/components/print";
import { formatDate } from "@/utils";

// 注册按需引入的element组件
Vue.use(element);

// 注册jsonp
Vue.use(VueJsonp);

Vue.config.productionTip = false;

// 注册全局指令
Object.keys(directives).forEach((key) => {
  Vue.directive(key, directives[key]);
});

Vue.directive("removeAriaHidden", {
  bind(el) {
    let ariaEls = el.querySelectorAll(".el-radio__original");
    ariaEls.forEach((item) => {
      item.removeAttribute("aria-hidden");
    });
  },
});

// 注册时间过滤器
Vue.filter("formatDate", formatDate);

Vue.prototype.$print = Print;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
